import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaPaperPlane } from 'react-icons/fa';

export default function ChatComposer({ value, onChange, onSend, disabled }) {
  const { t } = useTranslation();

  const canSend = !disabled && String(value || '').trim().length > 0;

  return (
    <div className="border-t border-gray-100 bg-white/80 backdrop-blur-md p-3 md:p-4">
      <div className="flex gap-3 items-end">
        <textarea
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          placeholder={t('chat.placeholder')}
          className="flex-1 border border-gray-200 rounded-2xl p-4 text-sm outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 min-h-[50px] max-h-36 bg-gray-50 focus:bg-white transition-all resize-none shadow-inner"
          disabled={disabled}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
              e.preventDefault();
              if (canSend) onSend?.();
            }
          }}
        />
        <button
          type="button"
          onClick={() => canSend && onSend?.()}
          disabled={!canSend}
          className={[
            'h-[50px] w-[50px] rounded-2xl font-extrabold text-sm flex items-center justify-center shadow-md transition-all duration-200',
            canSend 
              ? 'bg-indigo-600 text-white hover:bg-indigo-700 hover:shadow-indigo-500/30 hover:-translate-y-0.5' 
              : 'bg-gray-100 text-gray-400 cursor-not-allowed'
          ].join(' ')}
          title={t('chat.send_hint')}
          aria-label={t('chat.send')}
        >
          <FaPaperPlane className={canSend ? "ml-0.5" : ""} />
        </button>
      </div>
    </div>
  );
}


